<template>
  <div>
    <div class="container-fluid my-2">
      <div class="card-body">
        <div class="panel-body">
          <multi-selection-picker
            v-if="!readOnly"
            :all-items="availables"
            :allow-item-list-editing="!readOnly"
            :column-count="1"
            item-type-name="Necesidades"
            maxlength="1500"
            :modify-removes-item="true"
            :selected-items="selectedNeeds"
            @add-item="addNeeds"
            @delete-item="deleteNeeds"
            @edit-item="editNeeds"
          />
          <div v-if="!readOnly" class="row mt-3">
            <div class="col-12">
              <error
                is-alert-mode
                message="Escriba aquí para buscar un(a) Necesidad."
              />
            </div>
          </div>
          <custom-chips-group
            :disabled="readOnly"
            no-background
            no-wrap
            object-text="name"
            :on-item-deleted="removeSelection"
            :selected-items="selectedNeeds"
            title="Necesidades Seleccionadas"
          />
        </div>
      </div>
    </div>
    <div v-if="!readOnly" class="actions">
      <action-button i="fas fa-save" variant="success m-2" @click="save">
        Guardar
      </action-button>
    </div>
  </div>
</template>

<script>
import ActionButton from 'ActionButton';
import CustomChipsGroup from 'CustomChipsGroup';
import Error from 'custom-error';
import MultiSelectionPicker from '@/components/common/MultiSelectionPicker';

import alertMixin from '@quisit/mipe-utils/mixins/alert.mixin';

//services
import {
  getMeasureBankByUser as _getMeasureBankByUser,
  saveMeasureBankByUser as _saveMeasureBankByUser,
  deleteMeasureBankByUser as _deleteMeasureBankByUser,
} from '@/services/uspqrp/intervention-plan.api.js';

//utils
import measureBankTypes from '@/utils/constants/measureBankTypes.js';

export default {
  name: 'NeedsSection',
  components: {
    ActionButton,
    CustomChipsGroup,
    Error,
    MultiSelectionPicker,
  },
  mixins: [alertMixin],
  props: {
    readOnly: {
      type: Boolean,
      default: false,
    },
    disciplineTypeId: {
      type: Number,
      default: 0,
    },
    needs: {
      type: Array,
      default: new Array(),
    },
  },
  data() {
    return {
      availableNeeds: [],
      deletedNeeds: [],
    };
  },
  computed: {
    availables() {
      return this.availableNeeds.filter(
        (x) => !this.selectedNeeds.some((s) => s.name === x.name)
      );
    },
    selectedNeeds: {
      get() {
        return this.needs;
      },
      set(value) {
        this.$emit('update:needs', value);
      },
    },
  },
  async mounted() {
    await this.getMeasureBankByUser();
  },
  methods: {
    removeSelection(item) {
      let editedItemIndex = this.selectedNeeds.findIndex(
        (e) => e.id === item.id
      );
      this.selectedNeeds.splice(editedItemIndex, 1);
    },
    async addNeeds(description) {
      const { data: response } = await _saveMeasureBankByUser({
        id: null,
        measureTypeId: measureBankTypes.Needs,
        disciplineTypeId: this.disciplineTypeId,
        description: description,
      });
      this.availableNeeds.push({
        id: response.id,
        name: response.name,
      });
    },
    async editNeeds(item, index) {
      if (item.id > 0) {
        item.isDirty = true;
        const { data: response } = await _saveMeasureBankByUser({
          id: item.id,
          measureTypeId: measureBankTypes.Needs,
          disciplineTypeId: this.disciplineTypeId,
          description: item.name,
        });
        this.availableNeeds.splice(index, 1, {
          ...this.availableNeeds[index],
          name: response.name,
        });
      }
    },
    async deleteNeeds(item) {
      let response = await this.ShowCancelModal(
        'Atención',
        `¿Esta seguro que desea eliminar la fortaleza "${item.name}"?`,
        'Aceptar',
        'Cancelar'
      );

      if (response) {
        let itemIndex = this.availableNeeds.findIndex((e) => e.id === item.id);
        this.availableNeeds.splice(itemIndex, 1);
        this.deletedNeeds.push(item);
        await _deleteMeasureBankByUser(item.id);
      }
    },
    async save() {
      this.$emit('save');
    },
    async getMeasureBankByUser() {
      const { data: response } = await _getMeasureBankByUser(
        this.disciplineTypeId
      );
      if (response && response.length > 0) {
        this.availableNeeds = response.filter(
          (x) => x.measureTypeId === measureBankTypes.Needs
        );
      }
    },
  },
};
</script>
<style scoped>
.actions {
  display: flex;
  justify-content: flex-end;
}
</style>
